var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auth)?_c('b-container',{attrs:{"fluid":"","id":"layout_section_component"}},[_c('b-row',[_c('main-menu',{attrs:{"active":'news',"title":'News'}}),_vm._v(" "),_c('news-content')],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-399a9bba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/section/pages/News.vue
// module id = 0vf/
// module chunks = 0